import React, { FunctionComponent, useReducer } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CommunicateContext } from './context';
import { initialState, reducer } from './reducer';
import { WebViewClient } from './types';

export interface CommunicateProviderProps {
  languagePairId: number;
  locationSlug: string;
  client: WebViewClient;
  children: React.ReactNode;
}

export const CommunicateProvider: FunctionComponent<CommunicateProviderProps> = ({
  languagePairId,
  locationSlug,
  client,
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    languagePairId,
    locationSlug,
    client,
    sessionId: uuidv4(),
  });
  return (
    <CommunicateContext.Provider value={{ state, dispatch }}>
      {children}
    </CommunicateContext.Provider>
  );
};
